import { Col, Grid, Image, Row, Typography } from 'antd';

import { ButtonBorderKomunitasBeranda } from 'src/components/Forms/Button';

import classes from './index.module.less';

const JoinKomunitasBerandaContainer = () => {
	const { xs } = Grid.useBreakpoint();

	return (
		<div className={classes['page-body-wrap']}>
			<div className="container">
				<div className={classes.pagehero}>
					<Row>
						<Col
							md={12}
							sm={{ span: 12, order: 1 }}
							xs={{ span: 24, order: 1 }}
							lg={12}
							xl={12}
							style={{
								alignContent: 'center',
								justifyContent: 'center',
							}}
						>
							<div style={{ marginLeft: '40px', marginRight: '20px' }}>
								<h2 className={classes.title}>Yuk Ma, gabung dengan Komunitas HalloBumil</h2>
								<Typography className={classes.paragraph}>
									Temukan support, edukasi, dan inspirasi di setiap fase kehamilan hingga melahirkan
									dari Mama-mama lainnya
								</Typography>
								<div
									style={{
										marginTop: '10px',
										marginBottom: '20px',
										marginLeft: xs ? '10px' : '0px',
									}}
								>
									<a href={'/komunitas'} id="lihat-komunitas">
										<ButtonBorderKomunitasBeranda
											text={'Lihat Komunitas'}
										></ButtonBorderKomunitasBeranda>
									</a>
								</div>
							</div>
						</Col>
						<Col
							md={12}
							sm={{ span: 12, order: 2 }}
							xs={{ span: 24, order: 2 }}
							lg={12}
							xl={12}
							style={{
								textAlign: 'center',
								alignContent: 'center',
								justifyContent: 'center',
							}}
						>
							<div
								style={{
									textAlign: 'center',
									alignContent: 'center',
									justifyContent: 'center',
									marginLeft: '10px',
									marginRight: '10px',
								}}
							>
								{xs ? (
									<Image src="/images/branda/komunitas/komunitasJoin.webp" alt="komunitas-section" preview={false} />
								) : (
									<Image src="/images/branda/komunitas/komunitasJoin.webp" alt="komunitas-section" preview={false} />
								)}
							</div>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default JoinKomunitasBerandaContainer;
